var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-button-loading',{staticClass:"add-to-cart",class:{
    'is-rounded': _vm.rounded,
    'add-spacing': !_vm.loading,
    'is-small': _vm.small
  },attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"size":_vm.small ? 'small' : '',"aria-label":_vm.$slots.default ? undefined : 'In winkelwagen'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addToCart.apply(null, arguments)}}},[_c('q-icon',{class:{ 'text-lg': _vm.small },attrs:{"name":"cart"}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }